import React from "react"

import * as styles from "./Article.module.scss"

const Article = ({ children }) => <div className={styles.Article}>{children}</div>

export default Article
